// extracted by mini-css-extract-plugin
export default {"spin":"style_spin__lxWFc","iconpark-spin":"style_iconpark-spin__c+1w3","rtl":"style_rtl__F09pH","iconpark-spin-rtl":"style_iconpark-spin-rtl__KpzFq"};